import DateTimeDeadline from "../DateTimeDeadline";
import { Heading, StyledDeadlineBar } from "./styles";
import type { IProps } from "./type";

const DeadlineBar = ({ deadlineISO, deadlineLocal, headingText }: IProps) => (
  <StyledDeadlineBar>
    <Heading>{headingText}</Heading>
    <DateTimeDeadline displayDate={deadlineLocal} dateTime={deadlineISO} />
  </StyledDeadlineBar>
);

export default DeadlineBar;
